/**
 * @Author:
 * @Description:
 * @DateTime: Created in 23:01 2020/10/11
 */
import * as Vue from "vue-tsx-support";
import {Component, Prop, Emit} from 'vue-property-decorator'
import "vue-tsx-support/enable-check"
import _ from 'lodash'
import EnumItem from 'src/enums/enumItem';

export namespace CommonSelectVOI {
	export interface PropsI {
		value?: number|null|string|Array<number|null|string>
		clearable?: boolean
		filterable?: boolean
		readonly?: boolean
		multiple?: boolean
		disabled?: boolean
		transfer?: boolean
        placeholder?: string
        defaultOptionEnable?: boolean
		dataSource?: Array<{id: number, name: string}>
	}

	export interface EventI {
		onInput (value: number): void

		onChange (item: EnumItem|number): void
	}
}

@Component
export default class CommonSelect extends Vue.Component<CommonSelectVOI.PropsI, CommonSelectVOI.EventI> {
	@Prop({
		type: Boolean,
		default: false
	})
	multiple!: boolean

	@Prop({
		type: Boolean,
		default: false
	})
	disabled!: boolean

	@Prop({
		type: Boolean,
		default: false
	})
	readonly!: boolean

	@Prop({
		type: Boolean,
		default: false
	})
	transfer!: boolean

	@Prop({ 
		type: Boolean,
		default: true
	})
	clearable!: boolean

	@Prop({
		type: Boolean,
		default: false
	})
	filterable!: boolean

	@Prop({
		type: Number
	})
	type!: number

	@Prop({
		type: String
	})
	placeholder!: string

	@Prop({
		type: [Number, Array,String]
	})
	value!: number|null|Array<number|null|string>

	@Prop({
		type: Array
	})
    dataSource!: Array<{id: number,name: string}>
    
    @Prop({
        type: Boolean,
        default: false
	})
	defaultOptionEnable!: boolean

	@Emit('input')
	input (value: number) {
		return value
	}

	@Emit('clear')
	clear (value: number) {}

	@Emit('change')
	change (item: {value: number|string, label: string}|number|string) {
		return item
	}


	render (h) {
		return (
			<i-select
				filterable={this.filterable}
				transfer={this.transfer}
				class={{'wqms-select-readonly': this.readonly}}
				placeholder={this.placeholder}
				clearable={this.clearable}
				disabled={this.disabled|| this.readonly}
				on-input={this.input} on-on-clear={this.clear} value={this.value} on-on-change={this.change} multiple={this.multiple}>
                {
                    this.defaultOptionEnable && <i-option value={null} key={-2}>全部</i-option>
                }
				{
					this.dataSource.map((item) => <i-option value={item.id} key={item.id}>{item.name}</i-option>)
				}
			</i-select>
		)
	}
}
